// import Cookie from 'js-cookie'
// 401拦截
// import Router from 'vue-router'
import { removeToken, getToken, getTokenName } from '../utils/auth'
const resp401 = {
  /**
   * 响应数据之前做点什么
   * @param response 响应对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {*}
   */
  onFulfilled(response, options) {
    const { router, msg } = options
    if (response && response.data.code === 401) {
      msg.fail('登录超时')
      setTimeout(() => {
        removeToken()
        router.push('/login')
      }, 2000)
    }
    return response
     
    
    
  },
  /**
   * 响应出错时执行
   * @param error 错误对象
   * @returns {Promise<never>}
   */
  onRejected(error, options) {
    const {response} = error
    const {router, msg } = options
    if (response &&  response.data.code === 401) {
      msg.fail('登录超时')
      setTimeout(() => {
        removeToken()
        router.push('/login')
      }, 2000)
    }
    return Promise.reject(error)
  }
}

const resp403 = {
  onFulfilled(response, options) {
    const { msg } = options
    if (response && response.data.code === 403) {
      msg.fail('请求被拒绝')
      setTimeout(() => {
        removeToken()
        router.push('/login')
      }, 2000)
    }
    return response
  },
  onRejected(error, options) {
    const {response} = error
    const { msg } = options
    if (response && response.data.status === 403) {
      msg.fail('请求被拒绝')
      setTimeout(() => {
        removeToken()
        router.push('/login')
      }, 2000)
    }
    return Promise.reject(error)
  }
}





const reqCommon = {
  /**
   * 发送请求之前做些什么
   * @param config axios config
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {*}
   */
  onFulfilled(config, options) {
    const { router} = options
    // console.log(router, config, '什么');
    if ( getTokenName() && !getToken()) {
      router.push('/login')
    } else if(getToken()) {
      config.headers.Authorization = getToken()
    }
    // setTimeout(hide)
    return config
  },
  /**
   * 请求出错时做点什么
   * @param error 错误对象
   * @param options 应用配置 包含: {router, i18n, store, message}
   * @returns {Promise<never>}
   */
  onRejected(error, options) {
    options.msg.fail(error.message)
    return Promise.reject(error)
  }
}

export default {
  requests: [reqCommon], // 请求拦截
  response: [resp401, resp403] // 响应拦截
}
